// list controller
FeedbackController.$inject = ['$scope','feedbackService'];
function FeedbackController  ($scope, feedbackService){
    $scope.message = {};

    $scope.send = feedbackService.send
}

app.controller('FeedbackController', FeedbackController)
